import React from 'react';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import Samu from './image/booking/samu.png';
// Dữ liệu lịch trình chuyến đi Samu
const Schedule = [
  {
    day: "Chiều Thứ 6",
    activities: [
      { time: "06:30 PM", description: "Xe khởi hành từ Hà Nội, bắt đầu hành trình tìm về miền cổ tích Xím Vàng" },
      { time: "11:30 PM", description: "Có mặt và nhận phòng homestay tại Xím Vàng - Sơn La" },
      { 
        description: "Hãy để hương vị của núi rừng đưa bạn vào giấc ngủ ngon. Một cơ thể được nghỉ ngơi đầy đủ sẽ giúp bạn rạng rỡ và tràn đầy năng lượng để chinh phục những cung đường tuyệt đẹp vào ngày mai." 
      }
    ],
  },
  {
    day: "Thứ 7 - Lạc Vào Xứ Sở Rêu Phong",
    activities: [
      { time: "06:30 AM", description: "Ăn sáng tại homestay, thưởng thức cafe giữa mây ngàn" },
      { 
        description: "Bữa sáng ấm nóng với đầy đủ dinh dưỡng sẽ là 'nguồn nhiên liệu' hoàn hảo. Tại đây, đội ngũ hỗ trợ sẽ giúp bạn sắp xếp lại hành lý, những đồ dùng không cần thiết có thể gửi lại để đôi chân thêm nhẹ nhàng." 
      },
      { time: "07:30 AM", description: "Trải nghiệm xe ôm bản địa xuyên qua những đồi chè cổ thụ đến điểm leo" },
      { 
        description: "Cảm giác gió mơn man trên má và tầm mắt mở trọn ra thung lũng sẽ khiến tâm hồn bạn nhẹ bẫng. Mỗi khúc cua là một món quà của thiên nhiên dành tặng cho những người yêu tự do." 
      },
      { time: "09:00 AM", description: "Bắt đầu trekking vào khu rừng rêu huyền bí" },
      { 
        description: "Chào mừng bạn đến với vương quốc của rêu và sương mù. Những thân cây cổ thụ phủ kín rêu xanh mướt như trong phim điện ảnh sẽ khiến bạn ngỡ ngàng. Hãy cứ đi thật thong thả để cảm nhận sự kỳ diệu này nhé." 
      },
      { time: "12:00 PM", description: "Nghỉ chân và dùng bữa trưa giữa rừng già" },
      { 
        description: "Dưới những tán cây cổ thụ, một bữa trưa ngon miệng và giấc nghỉ ngắn 15 phút sẽ giúp trí não bạn thư thái, chỉ còn tiếng chim rừng và hơi thở của đại ngàn bên cạnh." 
      },
      { time: "04:30 PM", description: "Về tới lán nghỉ dừng chân" },
      { 
        description: "Lán nghỉ tọa lạc tại vị trí yên tĩnh, tách biệt hoàn toàn với thế giới ồn ào. Đây là lúc lý tưởng để bạn check-in với ánh hoàng hôn rực rỡ và tận hưởng sự bình yên tuyệt đối." 
      },
      { time: "06:30 PM", description: "Thưởng thức bữa tối ấm áp bên bếp lửa hồng" },
      { 
        description: "Trong không gian không sóng điện thoại, chúng ta sẽ xích lại gần nhau hơn qua những câu chuyện kể. Lán đã chuẩn bị sẵn chăn đệm ấm áp để bảo vệ sức khỏe và giấc ngủ của bạn trên đỉnh cao." 
      },
    ],
  },
  {
    day: "Chủ Nhật - Chinh Phục Đỉnh Cao & Thư Giãn Khoáng Nóng",
    activities: [
      { time: "05:00 AM", description: "Thức dậy, vệ sinh cá nhân và ăn sáng đầy đủ năng lượng" },
      { 
        description: "Đoạn đường lên đỉnh sắp tới sẽ là thử thách cuối cùng. Hãy kiểm tra lại trang phục và chuẩn bị một tinh thần quyết tâm để đón nhận phần thưởng quý giá nhất từ thiên nhiên." 
      },
      { time: "06:00 AM", description: "Bắt đầu chặng đường cuối chinh phục đỉnh Samu (2.665m)" },
      { 
        description: "Càng lên cao, không gian càng mở rộng. Dù địa hình có chút thử thách nhưng ánh sáng bình minh sẽ dẫn lối, mang lại vẻ đẹp thanh khiết và rạng rỡ cho hành trình của bạn." 
      },
      { time: "07:30 AM", description: "Chạm tay vào chóp Samu - Tận hưởng biển mây vô tận" },
      { 
        description: "Bạn đã làm được! Đứng trên đỉnh cao, hãy để những bức ảnh lưu giữ lại khoảnh khắc rạng rỡ nhất của thanh xuân. Đây chính là dấu ấn tự hào dành riêng cho sự nỗ lực của bạn." 
      },
      { time: "08:30 AM", description: "Bắt đầu xuống núi theo hướng Trạm Tấu" },
      { 
        description: "Cung đường xuống hướng Trạm Tấu mang vẻ đẹp khác lạ. Hãy lưu ý từng bước chân, thắt chặt dây giày để đảm bảo an toàn tuyệt đối cho đôi chân quý giá của mình." 
      },
      { time: "12:00 PM", description: "Dùng bữa trưa cuối cùng tại chân núi trước khi về thị trấn" },
      { time: "02:00 PM", description: "Thư giãn tuyệt đối tại suối khoáng nóng Trạm Tấu" },
      { 
        description: "Sau những ngày băng rừng, việc ngâm mình trong làn nước khoáng nóng tự nhiên là phương thuốc kỳ diệu để chữa lành cơ bắp, giúp bạn phục hồi năng lượng và làm làn da thêm tươi trẻ." 
      },
      { time: "05:30 PM", description: "Bữa tiệc liên hoan chúc mừng hành trình thành công" },
      { time: "07:30 PM", description: "Lên xe khởi hành về lại Thủ đô" },
      { 
        description: "Kiểm tra kỹ hành lý và mang theo những ký ức ngọt ngào. Hãy để chuyến xe đưa bạn vào giấc ngủ êm đềm trước khi trở lại với cuộc sống hối hả." 
      },
      { time: "11:30 PM", description: "Về tới Hà Nội. Kết thúc hành trình an toàn, trọn vẹn và đầy cảm hứng." }
    ],
  },
];

const SamuSchedule = () => {
  const exportPDF = () => {
    const input = document.getElementById("schedule");
    html2canvas(input, { scale: 1.5 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg", 0.7); // 0.7 = chất lượng nén
      const imgWidth = 210;
      const pageHeight = (canvas.height * imgWidth) / canvas.width;

      const pdf = new jsPDF("p", "mm", [imgWidth, pageHeight]);
      pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, pageHeight, null, "FAST");
      pdf.save("lich-trinh-ta-chi-nhu.pdf");
    });
  };


  return (
    <div>
    <div id="schedule" className="schedule-container" style={{ fontFamily: 'Arial, sans-serif', maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
      <div  className="day-schedule" style={{ marginBottom: '30px', borderLeft: '3px solid #6b8e23', paddingLeft: '15px' }}>
        <p className='block text-xl font-sans italic px-5 py-2'>🌿 Sa Mu (U Bò) – Cánh Rừng Nguyên Sinh Ma Mị và Kỳ Hoa Dị Thảo</p>
        <p className='block text-lg font-sans italic px-5 py-2'>
          Sa Mu (hay Sa Mu U Bò, độ cao 2.756m), ẩn mình trong rừng đặc dụng Tà Xùa (Sơn La), là cung đường trekking 
          với độ khó vừa phải, lý tưởng cho những ai muốn khám phá một khu rừng nguyên sinh bí ẩn và lãng mạn. 
          Nơi đây được ví như “Vương quốc của kỳ hoa dị thảo” và thảm thực vật phong phú, tạo nên một không gian 
          tách biệt hoàn toàn với thế giới bên ngoài.
        </p>
        <p  className='block text-lg font-italic font-sans italic px-5 py-2'>
          Ảnh: Thiên nhiên hoang sơ của Samu
        </p>
        <img src={Samu} alt="" className="w-96 bg-white shadow-md border-4 border-white p-5 rounded-lg w-11/12" />
      </div>
        <h2 className ='text-5xl' style={{ color: '#387338', borderBottom: '2px solid #a8c6a8', paddingBottom: '10px' }}>
          Chi tiết
        </h2>
      {Schedule.map((dayData, index) => (
        <div key={index} className="day-schedule" style={{ marginBottom: '30px', borderLeft: '3px solid #6b8e23', paddingLeft: '15px' }}>
          <h3 style={{ color: '#6b8e23', backgroundColor: '#f0fff0', padding: '5px 10px', borderRadius: '4px' }}>
            {dayData.day}
          </h3>
          <ul style={{ listStyle: 'none', paddingLeft: '0' }}>
            {dayData.activities.map((activity, idx) => (
              <li key={idx} className="activity-item text-lg font-sans " style={{ marginBottom: '15px', display: 'flex' }}>
                <strong style={{ minWidth: '85px', color: '#333' }}>
                  {activity.time}
                </strong>
                <span style={{ flexGrow: 1, paddingLeft: '10px' }}>
                  {activity.description}
                </span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <button 
        onClick={exportPDF}
        className=" m-5 px-5 py-2 bg-green-600 text-white px-4 py-2 rounded-md mb-4"
      >
        Xuất PDF
    </button>
  </div>
  );
};

export default SamuSchedule;